import React from 'react';
import { Box, TextBody, upToMd } from '@ally/metronome-ui';
import MenuLink from './MenuLink';
import { AccordionMenuItem, StyledSubMenuList } from './StyledMenuComponents';
import { StyledAccordionWrapper } from './AccordionSubMenu';
const ProfileSettingsContent = ({ routeLinks, closeMenu }) => {
    return (React.createElement(StyledSubMenuList, { "aria-label": "Profile and Settings" },
        React.createElement(AccordionMenuItem, null,
            React.createElement(TextBody, { tag: "span", size: "sm", tabIndex: -1 },
                React.createElement(MenuLink, { to: routeLinks.profile.bankUrl, text: routeLinks.profile.content, closeMenu: closeMenu }))),
        React.createElement(AccordionMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.username.bankUrl, text: routeLinks.username.content, closeMenu: closeMenu })),
        React.createElement(AccordionMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.password.bankUrl, text: routeLinks.password.content, closeMenu: closeMenu })),
        React.createElement(AccordionMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.loginSecurity.bankUrl, text: routeLinks.loginSecurity.content, closeMenu: closeMenu })),
        React.createElement(AccordionMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.marketingPreferences.bankUrl, text: routeLinks.marketingPreferences.content, closeMenu: closeMenu }))));
};
export default function GuestProfileSettings({ routeLinks, closeMenu, }) {
    return (React.createElement(Box, { mt: upToMd('lg', 'xl') },
        React.createElement(StyledAccordionWrapper, { key: "profile-settings-submenu", disableContainer: true, items: [
                {
                    heading: 'Profile and Settings',
                    panel: (React.createElement(ProfileSettingsContent, { routeLinks: routeLinks, closeMenu: closeMenu })),
                },
            ] })));
}
//# sourceMappingURL=GuestProfileSettingsMenu.js.map